import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SingleEdge, SortOption} from '../../../../graphql/generated/types';
import {CONTENT_HOME_STATE_NAME} from '../constant';
import {ContentHomeState} from './contentHomeState.interface';

export const contentHomeSlice = createSlice({
  name: CONTENT_HOME_STATE_NAME,
  initialState: {
    noticeNewDot: {},
    productListNewDot: {},
    isEnteredContentHome: {},
    productEdgeListMap: {},
    canRead: {},
    fetching: {
      about: {},
      recommend: {},
    },
    isHeaderIconStatic: false,
    needAutoScroll: true,
    needFetchOpenPreview: true,
    productListSortOption: undefined,
    isCheckedBoughtOnly: false,
  } as ContentHomeState,
  reducers: {
    setNoticeNewDot: (
      state,
      action: PayloadAction<{
        seriesId: number;
        newDot: boolean;
      }>
    ) => {
      state.noticeNewDot[action.payload.seriesId] = action.payload.newDot;
    },
    setProductListNewDot: (
      state,
      action: PayloadAction<{
        seriesId: number;
        newDot: boolean;
      }>
    ) => {
      state.productListNewDot[action.payload.seriesId] = action.payload.newDot;
    },
    setIsEnteredContentHome: (
      state,
      action: PayloadAction<{
        seriesId: number;
        isEntered: boolean;
      }>
    ) => {
      state.isEnteredContentHome[action.payload.seriesId] =
        action.payload.isEntered;
    },
    setCanRead: (
      state,
      action: PayloadAction<{
        seriesId: number;
        canRead: boolean;
      }>
    ) => {
      state.canRead[action.payload.seriesId] = action.payload.canRead;
    },
    updateProductEdgeListMap: (
      state,
      action: PayloadAction<{seriesId: number; edgeList: SingleEdge[]}>
    ) => {
      const {seriesId, edgeList} = action.payload;
      const totalEdgeListMap = state.productEdgeListMap[seriesId] || {};
      for (const singleEdge of edgeList) {
        totalEdgeListMap[singleEdge.cursor] = singleEdge.node;
      }
      state.productEdgeListMap[seriesId] = totalEdgeListMap || {};
    },
    clearProductEdgeListMap: (
      state,
      action: PayloadAction<{seriesId: number}>
    ) => {
      state.productEdgeListMap[action.payload.seriesId] = {};
    },
    setIsHeaderIconStatic: (state, action: PayloadAction<boolean>) => {
      state.isHeaderIconStatic = action.payload;
    },
    setNeedAutoScroll: (
      state,
      action: PayloadAction<{needAutoScroll: boolean}>
    ) => {
      state.needAutoScroll = action.payload.needAutoScroll;
    },
    setNeedFetchOpenPreview: (
      state,
      action: PayloadAction<{needFetchOpenPreview: boolean}>
    ) => {
      state.needFetchOpenPreview = action.payload.needFetchOpenPreview;
    },
    setProductListSortOption: (
      state,
      action: PayloadAction<{sortOption?: SortOption}>
    ) => {
      state.productListSortOption = action.payload.sortOption;
    },
    setIsCheckedBoughtOnly: (state, action: PayloadAction<boolean>) => {
      state.isCheckedBoughtOnly = action.payload;
    },
  },
});

export const {
  setCanRead,
  setNoticeNewDot,
  setProductListNewDot,
  setIsEnteredContentHome,
  updateProductEdgeListMap,
  clearProductEdgeListMap,
  setNeedAutoScroll,
  setNeedFetchOpenPreview,
  setProductListSortOption,
  setIsCheckedBoughtOnly,
  setIsHeaderIconStatic,
} = contentHomeSlice.actions;
